module.exports = __webpack_public_path__ + "img/activity_21.54d6a284.png";